import { createReducer } from 'utils/reduxCreators';
import { fetchSsoGroups, fetchSsoRoles } from 'services/ssoGroups';
import { updateAppLoading } from './meta';

export const RECEIVED_SSO_GROUPS = 'ssoGroups/RECEIVED_SSO_GROUPS';
export const RECEIVED_SSO_ROLES = 'ssoGroups/RECEIVED_SSO_ROLES';

const initialState = {
  groups: [],
  roles: [],
};

export default createReducer(initialState, {
  [RECEIVED_SSO_GROUPS]: (state, { payload }) => {
    return {
      ...state,
      groups: payload,
    };
  },
  [RECEIVED_SSO_ROLES]: (state, { payload }) => {
    return {
      ...state,
      roles: payload,
    };
  },
});

export const getSsoGroups = () => async (dispatch) => {
  dispatch(updateAppLoading(true));
  try {
    const groups = await fetchSsoGroups();
    dispatch(updateAppLoading(false));
    dispatch({ type: RECEIVED_SSO_GROUPS, payload: groups });
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};

export const getSsoRoles = () => async (dispatch) => {
  dispatch(updateAppLoading(true));
  try {
    const roles = await fetchSsoRoles();
    dispatch(updateAppLoading(false));
    dispatch({ type: RECEIVED_SSO_ROLES, payload: roles });
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};
